import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
//Needed for @capacitor/camera on web
import { defineCustomElements } from "@ionic/pwa-elements/loader";

import { AppModule } from "./app/app.module";
import { environment } from "src/environments/environment";

import * as Sentry from "@sentry/angular";

import { BUILD, VERSION, DATE } from "src/autogenerated-version";

if (!window.location.hostname.includes("localhost")) {
  Sentry.init({
    dsn: "https://f56e9185eaa01b5a651ca0ee609ff41e@o186379.ingest.us.sentry.io/4508834206187520",
    sendDefaultPii: true,
    environment: environment.NAME,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.captureConsoleIntegration(),
    ],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    release: `${VERSION}(${BUILD}-${DATE})`,
    dist: `${BUILD}-${DATE}`,
  });
} else {
  console.log("Sentry disabled on localhost");
}
// Disable console logs in production

//printHola();
//disableLogsOnProduction();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

// Call the element loader after the platform has been bootstrapped
// This causes Vite to show a warning
defineCustomElements(window);

function disableLogsOnProduction() {
  if (environment.NAME === "PROD") {
    window.console.log = () => {};
    window.console.warn = () => {};
    window.console.error = () => {};
  }
}
